import React from 'react';

const RoomView = () => {
    return <div className="roomView">
        <h2 className="roomView__section-title">Display examples</h2>

        <section className="roomView__section">
            <h3 className="roomView__subhead">Room view</h3>
            <div className="roomView-card roomView-card--room">
                <img className="roomView-card-img" src="/public/images/roomview.png" alt="Room view"/>
            </div>
        </section>

        <section className="roomView__section">
            <h3 className="roomView__subhead">Rate view</h3>
            <div className="roomView-card roomView-card--rate">
                <img className="roomView-card-img" src="/public/images/rateview.png" alt="Rate view"/>
            </div>
        </section>

        <section className="roomView__section">
            <h3 className="roomView__subhead">Card view</h3>
            <p className="roomView__helper">
                Guest click cards to view Room Details page where rates and Book Now call-to-action
                buttons are included.
            </p>
            <div className="roomView-card roomView-grid">
                <img className="roomView-card-img" src="/public/images/cardview.png"  alt="Card view"/>
            </div>
        </section>
    </div>
}
export default RoomView;


// WEBPACK FOOTER //
// ./src/components/helpers/roomView.js